import { RootState } from '../../store/store.state';
import { Actions, Effect } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { delay, filter, map, mergeMap } from 'rxjs/operators';
import { AddAlert, RemoveAlert } from './alerts.action';
import { of } from 'rxjs';

@Injectable()
export class AlertEffects {
    constructor(private actions$: Actions, private store: Store<RootState>) {}

    @Effect()
    autoDismiss$: Observable<Action> = this.actions$.pipe(
        filter(
            (action: Action) =>
                action instanceof AddAlert && action.payload.timer > 0
        ),
        mergeMap((action: AddAlert) =>
            of(action).pipe(delay(action.payload.timer))
        ),
        map((action: AddAlert) => new RemoveAlert(action.payload.id))
    );
}
